// extracted by mini-css-extract-plugin
export default {"box":"Box_box__BkAz1","gradient":"Box_gradient__uR5fK","header":"Box_header__9YIbx"};